import React from 'react';
import { motion } from 'framer-motion';

const Maktabi: React.FC<{ content?: any }> = ({ content }) => {
    const philosophyPoints = [1, 2, 3, 4, 5, 6, 7].map(i => content?.[`maktabi_phil_${i}`]).filter(Boolean);
    const displayPoints = philosophyPoints.length > 0 ? philosophyPoints : [
        "A distinct address of each company is to be placed on the entrance.",
        "To provide offices finished with the latest modern distinct decorations, and fully furnished with office furniture.",
        "Business to be managed by executive secretariat of vast experience.",
        "Availability of internet service (ADSL, WIFI)",
        "Meeting room furnished and equipped with all visual aids.",
        "Waiting Hall. Printing, photocopying, binding and packaging etc. Tea and Coffee delivery service.",
        "Public relations services and follow-up services of companies’ transactions with different Government authorities."
    ];

    return (
        <div className="max-w-7xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg border">
                <motion.section
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="bg-gradient-to-br from-gray-50 to-white py-10 rounded-3xl"
                >
                    <div className="max-w-7xl mx-auto px-6 lg:px-12 space-y-12">
                        {/* Intro */}
                        <div className="text-center max-w-5xl mx-auto">
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                                Maktabi
                            </h2>
                            <div className="text-sm md:text-base text-gray-600 leading-relaxed text-justify" dangerouslySetInnerHTML={{ __html: (content?.maktabi_intro || "It is a distinguished feature coupled with the concept of management and services of the furnished offices through providing a convenient, safe and integrated environment for companies and establishments.").replace(/\n/g, '<br/>') }} />
                        </div>

                        {/* Main Content (Profile + Service Philosophy) */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            {/* Left Content */}
                            <div>
                                <h2 className="text-1xl md:text-2xl font-bold text-gray-900 mb-6">
                                    Maktabi Profile
                                </h2>
                                <div className="text-gray-600 text-justify text-sm md:text-base leading-relaxed mb-6" dangerouslySetInnerHTML={{ __html: (content?.maktabi_profile_desc || "It is one of the leading companies in managing furnished offices, which are coupled with availability of simultaneous services through providing a convenient working environment for the companies, establishments and businessmen, whereas (My Office) provides the fully-equipped offices with different sizes that suit multiple services and business tastes, and which can be leased for periods of time that are subject to the lessee’s desire.").replace(/\n/g, '<br/>') }} />

                                <h3 className="text-1xl md:text-2xl font-bold text-gray-900 mb-4">
                                    Service Philosophy
                                </h3>
                                <ul className="space-y-3 text-sm text-gray-600">
                                    <li className="text-gray-600 text-justify text-sm md:text-base leading-relaxed">
                                        Lease of the fully furnished offices of different areas for periods of time as per lessee’s desire through providing reception and communication services by the following:-
                                    </li>

                                    {displayPoints.map((service, i) => (
                                        <motion.li
                                            key={i}
                                            initial={{ opacity: 0, x: -20 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.4, delay: i * 0.05 }}
                                            className="flex items-start space-x-3"
                                        >
                                            <span className="w-4 h-4 flex items-center justify-center rounded-full bg-red-100 text-red-600 font-semibold text-xs flex-shrink-0">
                                                {i + 1}
                                            </span>
                                            <span>{service}</span>
                                        </motion.li>
                                    ))}
                                </ul>

                                {/* Contact */}
                                <div className="mt-6 text-gray-800">
                                    <p className="text-sm">
                                        For more info, contact:{" "}
                                        <span className="font-bold">{content?.maktabi_phone || "95703672"}</span> or visit{" "}
                                        <a
                                            href={content?.maktabi_website || "https://www.maktabi.com"}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-blue-600 underline"
                                        >
                                            {content?.maktabi_website || "www.maktabi.com"}
                                        </a>
                                    </p>
                                </div>
                            </div>

                            {/* Right Image */}
                            <div className="relative">
                                <img
                                    src={content?.maktabi_image || "/Al Baz Center/Maktabi Profile.jpg"}
                                    alt="Maktabi Profile"
                                    className="rounded-xl shadow-xl object-cover w-full h-[400px]"
                                />
                                <p className="text-center text-sm text-gray-600 mt-3 font-medium">
                                    {content?.maktabi_image_caption || "Horizontal Sketch of Repeated Floors (5 – 6 – 7)"}
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </div>
        </div>
    );
};

export default Maktabi;
